import { useState } from 'react';

const faqList = [
  {
    q: 'Что такое кадровый резерв?',
    a: 'Кадровый резерв — это система выявления и подготовки сотрудников, которые потенциально могут занять определённые должности или взять на себя дополнительные зоны ответственности. Это не просто список перспективных людей, а процесс, в котором сотрудник целенаправленно готовится к будущей роли.',
  },
  {
    q: 'Зачем компании нужен кадровый резерв?',
    a: 'Кадровый резерв помогает заранее готовить будущих руководителей, снижать зависимость от внешнего найма, сохранять экспертизу внутри компании, готовиться к росту и обеспечивать преемственность на ключевых позициях. Кроме того, он показывает сильным сотрудникам возможную траекторию развития.',
  },
  {
    q: 'Как формируется кадровый резерв?',
    a: 'Формирование кадрового резерва проходит несколько этапов: определение будущих потребностей, описание профиля должности, выдвижение кандидатов, оценка, формирование индивидуальных планов развития, само развитие через обучение и практику, наблюдение и обратная связь, повторная оценка и подготовка к назначению.',
  },
  {
    q: 'Кого включают в кадровый резерв?',
    a: 'Критерии зависят от будущей роли. При отборе учитывают результаты работы, профессиональные компетенции, управленческий потенциал, способность учиться, самостоятельность, ответственность, коммуникацию, готовность брать дополнительную ответственность и мотивацию к развитию. Высокий результат не означает автоматическую готовность к повышению.',
  },
  {
    q: 'Как оценить кандидатов в кадровый резерв?',
    a: 'Оценка определяет текущий уровень компетенций, потенциал и зоны развития. Используются результаты оценки компетенций, интервью, обратная связь, наблюдение и рабочие показатели. Для будущих руководителей отдельно оцениваются управленческие компетенции, потому что лучший специалист не всегда становится лучшим руководителем.',
  },
  {
    q: 'Чем кадровый резерв отличается от списка сотрудников на повышение?',
    a: 'Список на повышение лишь фиксирует кандидатов, а кадровый резерв предполагает системную подготовку. Резервист получает индивидуальный план развития, практику, наставничество и обратную связь. Сам факт включения в резерв ничего не развивает — важна именно работа по подготовке к будущей роли.',
  },
  {
    q: 'Как развивать сотрудников кадрового резерва?',
    a: 'Развитие резервиста не ограничивается обучением. Используются разные инструменты: обучение, практика, наставничество, развивающие задачи, проектная работа, временная замена руководителя, регулярная обратная связь и коучинг. Инструмент подбирается под конкретный дефицит компетенций.',
  },
  {
    q: 'Как связан кадровый резерв с ИПР?',
    a: 'Кадровый резерв отвечает на вопрос, кого компания готовит к будущей роли, а индивидуальный план развития — что конкретно этому сотруднику нужно развить. Для каждого резервиста формируется ИПР, который описывает компетенции, действия, инструменты, сроки и критерии результата.',
  },
  {
    q: 'Нужно ли обучать сотрудников кадрового резерва?',
    a: 'Обучение — один из инструментов, но не единственный. Для одной компетенции нужен тренинг, для другой — практика, для третьей — наставничество, для четвёртой — работа над реальным проектом. Если у многих резервистов общий дефицит, обучение можно организовать в виде корпоративной программы.',
  },
  {
    q: 'Как подготовить сотрудника к должности руководителя?',
    a: 'Переход от специалиста к руководителю требует развития новых компетенций: лидерство, постановка задач, делегирование, контроль, обратная связь, мотивация, управление конфликтами, принятие решений, коммуникация и управление изменениями. Эти навыки развиваются через обучение и обязательную практику в реальных рабочих ситуациях.',
  },
  {
    q: 'Как оценить готовность резервиста к новой должности?',
    a: 'Готовность оценивается через сравнение текущего уровня компетенций с требованиями будущей роли. Определяется разрыв, составляется план развития, сотрудник получает практику, затем проводится повторная оценка. На её основе делается вывод, готов ли человек к назначению или требует дальнейшего развития.',
  },
  {
    q: 'Кто должен отвечать за кадровый резерв — HR или руководитель?',
    a: 'Это совместная ответственность. HR/L&D организует систему, инструменты и контроль, а руководитель помогает определить приоритеты, даёт обратную связь и создаёт возможности для практики. Если резерв существует только в HR-системе и не используется руководителем, он быстро становится формальным.',
  },
  {
    q: 'Можно ли создать кадровый резерв для небольшой компании?',
    a: 'Да, для небольшой компании кадровый резерв может быть компактным: несколько ключевых ролей и несколько сотрудников, которых готовят к ним. Важна не масштабность системы, а её практичность: понятные будущие роли, оценка, планы развития и регулярная обратная связь.',
  },
  {
    q: 'Как избежать формального отношения к кадровому резерву?',
    a: 'Формальность появляется, когда создают список резервистов и ничего не делают дальше. Чтобы этого избежать, нужно определять конкретную будущую должность, формировать индивидуальные планы развития, давать практику, подключать руководителя и наставника и проводить повторную оценку результата.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Часто задаваемые вопросы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы о формировании и развитии кадрового резерва
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4 text-sm md:text-base">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}